module.exports = __webpack_public_path__ + "static/img/product-swipe25.9c6f1ecc.png";